export default class eventSubscriberInfo {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/event-subscriber-info.html'),
            scope: {
                subscriber: '=',
                eventData: '=',
                status: '=',
                loading: '='
            },
            controller: ['$scope', '$element', '$attrs', (scope, element, attributes) => {
                scope.show = false;

                scope.$on('event:attenderInfo:show', () => {
                    scope.show = true;
                });

                scope.$on('event:attenderInfo:close', () => {
                    scope.show = false;
                });

                $(document).keyup((e) => {
                    if (e.keyCode == 27 && scope.show) {
                        scope.show = false;
                    }
                });

                scope.close = () => {
                    scope.show = false;
                };

                scope.removeSubscription = () => {
                    scope.$emit('event:attenderInfo:removeSubscription');
                };
            }]
        }
    }
}
